<!-- <select class="form-control" [(ngModel)]="value">
    <option *ngFor="let state of stateAndProvinces" [value]="state.Abbreviation" >
        {{displayAbbreviation ? state.Abbreviation : state.Name}}
    </option>
</select> -->

<p-select
  dataKey="Abbreviation"
  optionLabel="Abbreviation"
  placeholder="{{ 'common.personal-information.state' | translate | titlecase }}"
  [(ngModel)]="selectedStateProvince"
  [options]="stateAndProvinces"
  styleClass="minWidthOverride"
  [disabled]="disabled"
  editable="true"
  wlEditableSelectFocusFix
></p-select>
